import React, { useEffect, useState } from "react";
import { TextField, Select, MenuItem, Button, Box, Typography, Autocomplete, Grid } from "@mui/material";
import { ReactComponent as PlushIcon } from "../../assets/dashboardIcons/plusicon.svg"
import { ReactComponent as Wifi } from "../../assets/dashboardIcons/wifiIcon.svg"
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useForm, Controller } from "react-hook-form";
import MenuWithPDF from "../filter/MenuWithPDF";
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import { useDispatch, useSelector } from "react-redux";
import { selectProdotti } from "../../features/Prodotti/prodottiSlice";
import { fetchProdotti } from "../../features/Prodotti/prodottiThunk";
import { fetchProduzioineRaccolta } from "../../features/produzioniFormData/produzioniFormDataThunk";
import produzioniFormAPI from "../../services/produzioniFormApi";
dayjs.locale('it');

const TableInputField = ({ option, rows, setRows, activeStep }) => {
    const dispatch = useDispatch();
    const singleProduzioneID = useSelector((state) => state.produzioni.singleProduzioneId);
    const productOptions = useSelector(selectProdotti);
    const metodoOptions = useSelector((state)=> state.produzioniForm.raccolta)

    const { control, setValue, formState: { errors } } = useForm();

    useEffect(() => {
        dispatch(fetchProdotti())
        dispatch(fetchProduzioineRaccolta()) 
    }, [dispatch])

    // const [rows, setRows] = useState([
    //     { id: 1, datetime: null, method: "", quantity: "", discarded: "", temperature: "", product: "" },
    //     { id: 2, datetime: null, method: "", quantity: "", discarded: "", temperature: "", product: "" },
    // ]);

    const handleInputChange = (index, field, value) => {
        const updated = [...rows];
        updated[index][field] = value;
        setRows(updated);   // Lifts the change up
    };

    const addRow = () => {
        setRows([
            ...rows,
            { company_id: Number(localStorage.getItem('company_id')) || "", step: activeStep, prod_id: singleProduzioneID,  metto_di_raccolta: "", qty: "", uva_scartata: "", room_temperature: "", prodotto_id: "" }
        ]);
    };

    const handleDelete = async (index) => {
        const row = rows[index];
    
        if (row.id) {
          try {
            await produzioniFormAPI.deleteStepFormRow({
                id: row.id, 
                formName: "raccoltauva"
            });
          } catch (err) {
            console.error("Error deleting row from server:", err);
            return;
          }
        }

        setRows((prev) => prev.filter((_, i) => i !== index));
      };

    return (
        <Box className="tableInput" sx={{ maxWidth: "100%", padding: 2 }}>
            {/* Heading */}
            <h3 className="sectiontitleSmall">Lotti di raccolta uva</h3>

            {/* Column Titles */}
            <Grid container spacing={1} sx={{ marginBottom: 1, fontWeight: "bold", color: "gray" }}>
                <Grid size={.5}><Typography>ID</Typography></Grid>
                {/* <Grid size={1.8}><Typography>Data e ora di raccolta</Typography></Grid> */}
                <Grid size={1.8}><Typography>Prodotto</Typography></Grid>
                <Grid size={1.8}><Typography>Metodo di raccolta</Typography></Grid>
                <Grid size={1.8}><Typography>Q.ta raccolta (Kg)</Typography></Grid>
                <Grid size={1.8}><Typography>UVA scartata (Kg)</Typography></Grid>
                <Grid size={2.4}>
                    <Box className="inputBoxIcon heading">
                        <p>
                            Temperatura ambiente (°)
                        </p>
                        <Wifi className="wifiIcon" />
                    </Box>
                </Grid>
            </Grid>

            {/* Dynamic Rows */}
            {rows?.map((row, index) => (
                <Grid container spacing={1} key={row.id || index} sx={{ marginBottom: 1 }}>
                    <Grid size={.5}>
                        <TextField
                            label="ID"
                            size="small"
                            value={row.id || index}
                            disabled />
                    </Grid>

                    {/* <Grid size={1.8}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                            <Controller
                                name={`datetime-${index}`}
                                control={control}
                                render={({ field }) => (
                                    <DatePicker
                                        className='datePickerField'
                                        label="Data e ora di raccolta"
                                        value={field.value ? dayjs(field.value) : null}
                                        inputFormat="YYYY-MM-DD"
                                        onChange={(newValue) => {
                                            handleInputChange(index, "datetime", newValue);
                                            field.onChange(newValue);
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                error={!!errors[`datetime-${index}`]}
                                                helperText={errors[`datetime-${index}`]?.message}
                                                fullWidth
                                                margin="normal"
                                                size="small"
                                            />
                                        )}
                                    />
                                )}
                            />
                        </LocalizationProvider>
                    </Grid> */}

                    <Grid size={1.8}>
                        <Autocomplete
                            options={productOptions}
                            getOptionLabel={(option) => option.commercial_name || ''}
                            value={productOptions.find((option) => option.id == row.prodotto_id) || null} 
                            getOptionKey={(option) => option?.id || ""}
                            onChange={(event, newValue) => handleInputChange(index, "prodotto_id", newValue?.id || "")}
                            renderInput={(params) => (
                                <TextField {...params}
                                    className="customTextBox autoCompleteTextBox"
                                    label="Prodotto"
                                    size="small" />
                            )}  
                        />
                    </Grid>

                    <Grid size={1.8}>
                        <Autocomplete
                                options={metodoOptions}
                                value={row.metto_di_raccolta || ""} 
                                onChange={(event, newValue) => handleInputChange(index, "metto_di_raccolta", newValue)}
                                renderInput={(params) => (
                                    <TextField {...params}
                                        className="customTextBox autoCompleteTextBox"
                                        label="Metodo"
                                        size="small" />
                                )}  
                            />
                    </Grid>
                    <Grid size={1.8}>
                        <TextField
                            defaultValue=""
                            className="customTextBox"
                            label="Q.ta raccolta (Kg)"
                            value={row.qty || ""}
                            onChange={(e) => handleInputChange(index, "qty", e.target.value)}
                            size="small"
                        />
                    </Grid>
                    <Grid size={1.8}>
                        <TextField
                            defaultValue=""
                            className="customTextBox"
                            label="UVA scartata (Kg)"
                            value={row.uva_scartata || ""}
                            onChange={(e) => handleInputChange(index, "uva_scartata", e.target.value)}
                            size="small"
                        />
                    </Grid>
                    <Grid size={2.4}>
                        <Box className="inputBoxIcon">
                            <TextField
                                defaultValue=""
                                className="customTextBox"
                                label="Temperatura (°C)"
                                value={row.room_temperature || ""}
                                onChange={(e) => handleInputChange(index, "room_temperature", e.target.value)}
                                size="small"
                            />
                            <Wifi className="wifiIcon" />
                        </Box>

                    </Grid>
                    <Grid size={.1}>
                        <MenuWithPDF
                            options={option}
                            handleDelete={(event) => {
                                event?.stopPropagation();
                                handleDelete(index);
                            }}
                            id={row.id}
                        />
                    </Grid>
                </Grid>
            ))}

            {/* Add Button */}
            <Button
                variant="body2"
                onClick={addRow}
                sx={{
                    cursor: 'pointer', color: "#225CA6", mt: 1, gap: "6px",
                    fontFamily: '"Public Sans", sans-serif !important',
                    '&:hover': {
                        color: '#57C700',
                        background: "transparent"
                    }
                }}
            >
                <PlushIcon

                /> aggiungi lotto
            </Button>

        </Box>
    );
};

export default TableInputField;
